export enum brandType {
  BABYLONSTOREN = 'Babylonstoren',
  THENEWT = 'The Newt',
  VIGNAMAGGIO = 'Vignamaggio'
}